module.exports = __webpack_public_path__ + "images/facebook_hover-befba39f560bcb662ed49f2b3fcd4ff2.png";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/facebook_hover.png
// module id = 36
// module chunks = 0